import { IUtilityTab } from '../models/navigation/navigation-hub.model';

export abstract class NavigationData {
    public static tabs: IUtilityTab[] = [
        {
            name: 'main',
            link: {
                href: 'https://universal-robots.com/',
                title: 'UR.com',
                tracking: {
                    parameters: {
                        identifier: 'utility_bar/urcom',
                    },
                },
            },
        },
        {
            name: 'academy',
            link: {
                href: 'https://academy.universal-robots.com/',
                title: 'Academy',
                tracking: {
                    parameters: {
                        identifier: 'utility_bar/academy',
                    },
                },
            },
            regionalLinks: [
                {
                    href: 'https://academy.universal-robots.cn/',
                    cultures: ['zh-Hans'],
                },
            ],
        },
        {
            name: 'urconnect',
            link: {
                href: 'https://myur.universal-robots.com/',
                title: 'UR Connect',
                tracking: {
                    parameters: {
                        identifier: 'utility_bar/urconnect',
                    },
                },
            },
        },
        {
            name: 'customers',
            link: {
                href: 'https://customers.teradyne-robotics.com/',
                title: 'Customers',
                tracking: {
                    parameters: {
                        identifier: 'utility_bar/customers',
                    },
                },
            },
        },
        {
            name: 'partners',
            link: {
                href: 'https://partners.universal-robots.com/',
                title: 'Partners',
                tracking: {
                    parameters: {
                        identifier: 'utility_bar/partners',
                    },
                },
            },
        },
    ];
}
